import React, {useContext, useState, memo, useEffect} from "react";
import {TemplateContext} from "@common/context/TemplateContext";
import ListGroup from "@common/ListGroup";
import ListItem from "@common/ListItem";
import {animateScroll, scroller} from "react-scroll";

const PageMarkerNavigation = props => {
    const {startOpen = true, tabIndex = 0} = props;
    const {navigationLinks} = useContext(TemplateContext);
    const [groupedNavigationLinks, setGroupedNavigationLinks] = useState([]);
    let otherListGroupOptions  = {}
    if (props.indicatorPlacement) otherListGroupOptions.indicatorPlacement = props.indicatorPlacement;

    useEffect(() => {
        setGroupedNavigationLinks(sortNavigationLinks(navigationLinks));
    }, [navigationLinks]);

    function sortNavigationLinks(objects) {
        const rootObjects = [];
        const lookup = {};
        objects.forEach((obj) => {
            const id = obj.id;
            const parentId = obj.parent;
            obj.children = [];
            lookup[id] = obj;
            if (!parentId) {
                rootObjects.push(obj);
            } else {
                const parentObj = lookup[parentId];
                if (parentObj) {
                    parentObj.children.push(obj);
                }
            }
        });
        return rootObjects;
    }

    if(navigationLinks == null || navigationLinks.length == 0) {
        return null;
    }

    return (
        <ul role="menu" className={'ch-list ch-page-marker-nav'}>
            <ListGroup title="Shortcuts" itemCount={navigationLinks.length + 1} startOpen={startOpen} {...otherListGroupOptions}>
                <NavigationLink key={0} tabIndex={0} navigationLink={{title: 'Top', navigationIndex: -1}} />
                {
                    groupedNavigationLinks.map((navigationLink, index) => {
                        return <NavigationLink key={index + 1} tabIndex={-1} navigationLink={navigationLink} otherListGroupOptions={otherListGroupOptions} />
                    })
                }
            </ListGroup>
        </ul>
    )
}

const NavigationLink = props => {
    const {navigationLink, otherListGroupOptions} = props;

    if (navigationLink.children && navigationLink.children.length > 0) {
        return (
            <ListGroup data-navigation-index-link={navigationLink.navigationIndex} title={navigationLink.title} startOpen={false} onNavigationClick={() => handleNavigationClick(navigationLink.navigationIndex)} {...otherListGroupOptions}>
                {navigationLink.children.map((navLink, index) => {
                    return <NavigationLink key={index} navigationLink={navLink} />
                })}
            </ListGroup>
        )
    } else {
        return (
            <ListItem data-navigation-index-link={navigationLink.navigationIndex} onClick={() => handleNavigationClick(navigationLink.navigationIndex)}>
                {navigationLink.title}
            </ListItem>
        )
    }
}

function ScrollToPageMarker(navigationIndex) {
    handleNavigationClick(navigationIndex);
}

const handleNavigationClick = (navigationIndex) => {
    let el = undefined;
    if(navigationIndex === -1) {
        animateScroll.scrollToTop({
            containerId: 'contentPanel',
            duration: 0,
            delay: 0,
        });
    } else {
        scroller.scrollTo('page-marker-' + navigationIndex, {
            containerId: 'contentPanel',
            offset: -50,
            duration: 800,
            delay: 0,
        });
    }
}

export {
    PageMarkerNavigation,
    ScrollToPageMarker
}